import { render } from "./SubThemesMain.vue?vue&type=template&id=0a8ae894"
import script from "./SubThemesMain.vue?vue&type=script&lang=js"
export * from "./SubThemesMain.vue?vue&type=script&lang=js"

import "./SubThemesMain.vue?vue&type=style&index=0&id=0a8ae894&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__